<template>
  <v-btn :color="color" text @click="navigate" class="backButton" :disabled="isDisabled">
    {{ $t(`components.login.LoginComponentNavigationButton.${to}`) }}
  </v-btn>
</template>

<script lang="ts">
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { Component, Prop, Vue } from "vue-property-decorator";
import { FeatureModule } from "@/store/modules/feature.store";

@Component({
  components: {}
})
export default class LoginComponentNavigationButton extends Vue {
  @Prop()
  to!: string;

  @Prop({ default: false })
  isDisabled?: boolean;

  navigate() {
    this.$router.push({ path: this.to });
  }

  get color() {
    if (FeatureModule.isNavigationInPartnerColors) {
      return getDefaultPartnerColor();
    }

    return "primary";
  }
}
</script>
<style scoped>
.backButton {
  width: 100%;
}
</style>
